import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Request, Notification, humanize, parseJSON, createIcon, runtime, twoDecimal, Util } from '../../common';
import { UIComponent, Cluster, View, getThemeColor, getThemeColorValue, mapClusterKey, EmptySlim } from '../Base';
import { getSrc, parseSrc } from '../Explorer';
import { Divider, LinearProgress, Avatar } from '@material-ui/core';
import Badge from '../Badge';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Button, { Link, GoLink } from '../Button';
import Modal from '../Modal';
import CheckIcon from '@material-ui/icons/Check';
import { Html } from '../Html';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
//封装了一些常用小组件

export class ProgressModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      percent: 0
    }
  }

  open() {
    this.refs.modal.open();
  }

  close() {
    this.setState({
      percent: 0,
    })

    this.refs.modal.close();
  }

  set(v) {
    this.setState({
      percent: v
    })

  }

  render() {
    let { percent } = this.state;
    let { title } = this.props;
    percent = Util.empty(percent) ? 0 : percent;
    return (
      <Modal drawer={false} ref={"modal"} size="xs">
        <div className={`bg-white p-3`}>
          <p className="c-text-s2 mb-2">{twoDecimal(percent) + "%"}</p>
          <LinearProgress color="primary" className={percent == 100 ? "c-progress-success" : ""} variant="determinate" value={percent} />
          <p className="c-text-s2 mt-2 c-mb-0">{title}</p>
        </div>
      </Modal>
    )
  }
}

ProgressModal.defaultProps = {
  percent: 0,
  title: "正在导入数据",
}

export class Row extends React.Component {

  constructor(props) {
    super(props);
  }

  renderDefault() {
    let { color, label } = this.props;
    return <p className={`c-text-s1 c-text-md-s2 mb-0 c-text-${color}`}>{label}</p>;
  }

  handleClick() {

  }

  render() {
    let { line, children } = this.props;
    return (
      [<div key={0} className={`d-flex flex-row justify-content-center align-items-center py-2 c-mh3 c-md-mh4`} onClick={this.handleClick.bind(this)}>
        {children || this.renderDefault()}
      </div>, line ? <Divider key={1} /> : null]
    );
  }
}

Row.defaultProps = {
  line: true,
  color: "dark"
}


//在移动端显示隐藏元素、在PC端只有鼠标划过时才会显示元素
export class Hover extends UIComponent {

  constructor(props) {
    super(props);
  }

  enter() {
    this.getMembers().forEach((e) => {
      e.show();
    });
  }

  leave() {
    this.getMembers().forEach((e) => {
      e.hide();
    });
  }


  getMembers() {
    let { master } = this.props;
    return Cluster.getSlaves(master);
  }


  componentWillMount() {
    super.componentWillMount();

    let { master } = this.props;
    if (master) {
      this.master = { "hover": mapClusterKey(master) };   //成员需要实现 hide和show方法
      Cluster.openMaster(this);
    }
  }

  componentDidMount() {
    super.componentDidMount();
    if (runtime.pc) {
      this.leave();
    }
  }


  render() {
    let { className, children } = this.props;
    let p = runtime.pc ? { onMouseEnter: () => { this.enter() }, onMouseLeave: () => { this.leave(); } } : null;
    return <div className={className} {...p} >
      {children}
    </div>
  }
}

Hover.defaultProps = {
  className: ''
}


export class HoverItem extends UIComponent {

  constructor(props) {
    super(props);
    this.state = {
      show: true
    }
  }

  hide() {
    this.setState({ show: false });
  }

  show() {
    this.setState({ show: true });
  }


  render() {
    let { className } = this.props;
    let p = { ...this.props };
    delete p.className;
    let { show } = this.state;
    let showClassName = show ? '' : "c-d-none";
    return <div className={`${className} ${showClassName}`} {...p} >
    </div>
  }
}

HoverItem.defaultProps = {
  className: ''
}



export class Section extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    let { className, iconClassName, icon, tools, title, titleClassName } = this.props;
    icon = createIcon(icon, `text-grey mr-2 ${iconClassName}`);
    return (
      <div className={`d-flex flex-column ${className}`}>
        <div className={`d-flex flex-row justify-content-between align-items-center`}>
          <div className="d-flex flex-row align-items-center">
            {icon}
            <p className={`mb-0 text-dark ${titleClassName}`}>{title}</p>
          </div>
          <div className="d-flex flex-row align-items-center">
            {tools}
          </div>
        </div>
        <Divider className="mt-2" />
      </div>
    )
  }
}

Section.defaultProps = {
  className: 'p-1 p-sm-3',
  iconClassName: 'c-icon-s2 c-icon-sm-s3',
  titleClassName: 'c-text-s2 c-text-sm-s3'
}




export class BadgeRow extends React.Component {

  constructor(props) {
    super(props);
  }

  getConfig() {
    let { size } = this.props;
    switch (size) {
      case "md": return { description: "c-text-s2", badge: "c-badge-md" }
      case "sm": return { description: "c-text-s1d5", badge: "c-badge-md" }
      case "xs":
      default: return { description: "c-text-s1", badge: "c-badge-md" }
    }
  }

  render() {
    let { badge, description, className, descriptionClassName, backgroundColor, right, rightClassName, onClick, align } = this.props;
    let config = this.getConfig();
    var p = {};
    if (onClick) {
      p.onClick = (e) => { e.stopPropagation(); if (onClick) onClick(); };
    }
    return (
      <div className={`p-0 d-flex flex-row c-bg-${backgroundColor} ${onClick ? "c-pointer" : null}`} {...p} >
        <div className={`d-flex w-100 p-2 justify-content-between c-radius ${className}`}>
          <div className={`d-flex align-items-${align}`}>
            {
              badge ? (
                <div className={`d-flex align-items-${align} ${config.height}`} >
                  {badge.component ? badge.component : <Badge color={badge.color} className={`m-0 mr-2 ${config.badge} ${badge.className || ''}`}>{badge.content}</Badge>}
                </div>
              ) : null
            }
            <div className={`d-flex align-items-${align} ${config.height}`}>
              {Util.type(description) === "string" ?
                <p className={`mb-0 c-wrap ${config.description} ${descriptionClassName}`}>{description}</p> :
                <div className={`mb-0 c-wrap ${config.description} ${descriptionClassName}`}>{description}</div>
              }
            </div>
          </div>
          {
            right ?
              <div className={`d-flex align-items-center c-h-100 ${rightClassName}`}>
                {right}
              </div>
              : null
          }
        </div>
      </div>
    );
  }
}

BadgeRow.defaultProps = {
  badge: { color: "green", content: "" },
  className: "flex-row align-items-center",
  descriptionClassName: "",
  size: "sm",
  backgroundColor: "light-slim",
  right: <KeyboardArrowRightIcon className="c-icon-s2 mb-0 c-text-grey" />,
  rightClassName: '',
  align: "center"  //用于控制内容多行情况下，垂直布局，start:置顶，center:居中
}


export class BadgeHtml extends React.Component {

  constructor(props) {
    super(props);
  }


  render() {
    let { className, title, right, description } = this.props;
    return (
      <div className={`d-flex flex-column ${className}`}>
        <BadgeRow badge={null} size="sm" descriptionClassName="ml-2 m-text-dark-75 font-weight-bold" description={title} right={right} />
        <Html className="my-2 mx-2" textClassName="c-text-s2 mb-0 m-text-dark-50" code={description} />
      </div>
    );
  }
}

BadgeHtml.defaultProps = {
  className: ""
}


export class Columnar extends React.Component {

  constructor(props) {
    super(props);
  }


  render() {
    let { color, className, size } = this.props;
    color = getThemeColorValue(color)
    return (
      <span className={`c-columnar c-columnar-${size} ${className}`} style={{ backgroundColor: color }}></span>
    );
  }
}

Columnar.defaultProps = {
  color: "danger",
  size: "xs",
  className: ""
}


//醒目的提示，下面可以接链接操作
export class Striktor extends React.Component {

  constructor(props) {
    super(props);
  }

  onClick(e) {
    let { link } = this.props;
    if (link.click) link.click(e);
  }

  render() {
    let { title, link, className } = this.props;
    return (
      <div className={`d-flex flex-column w-100 justify-content-center align-items-center ${className}`}>
        <div className="mt-2" >
          <p className="text-grey c-text-s3 c-text-sm-s5 mb-2 mb-sm-3">{title}</p>
        </div>
        {
          link ? <div className="mt-1 mt-md-0">
            <Link textClassName={"c-text-s2 c-text-sm-s4"} leftIconClassName="c-text-s4 c-mb-0d5" leftIcon={link.icon} onClick={(e) => { this.onClick(e); }} >{link.title}</Link>
          </div> : null
        }
      </div>
    );
  }
}

Striktor.defaultProps = {
  className: ''
}


//ButtonGroup

export class ButtonGroup extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selected: []
    }
  }

  componentWillReceiveProps(nextProps) {
    let { data: ov } = this.props;
    let { data: nv } = nextProps;
    if (!Util.equals(ov, nv)) {
      this.handleChange(nv.map((t) => t.value));
    }
  }

  get() {
    let { selected } = this.state;
    return selected;
  }

  set(v) {
    if (v != null) this.setState({ selected: v });
  }


  addOrRemove(item) {
    let { selected } = this.state;
    let index = null;

    let target = selected.find((t, i) => {
      if (t == item.value) { index = i; return true; }
      return false;
    });

    if (target)
      selected.splice(index, 1)
    else
      selected.push(item.value);

    this.handleChange(selected);
  }

  handleChange(v) {
    let { onChange } = this.props;
    this.setState({ selected: v }, () => {
      if (onChange)
        onChange(v);
    });
  }

  render() {
    let { data, color, size, buttonClassName, selectedColor } = this.props;
    let { selected } = this.state;
    return (
      <div className="d-flex flex-row flex-wrap">
        {
          data.map((item, i) => {
            let check = selected.find(s => s == item.value);
            let tColor = check ? selectedColor : color;
            return (
              <div key={i} className={`m-1 m-sm-2`}>
                <Button responsive={false} className={buttonClassName} color={tColor} size={size} onClick={() => { this.addOrRemove(item); }}>
                  {item.label}
                </Button>
              </div>
            )
          })
        }
      </div>
    )
  }
}

ButtonGroup.defaultProps = {
  data: [],
  color: "white",
  selectedColor: "blue",
  buttonClassName: ''
}


export const Header = ({ title }) => {
  return (
    <div className="page-heading d-sm-flex justify-content-start align-items-center p-4">
      <h2 className="title mb-0">{title}</h2>
    </div>
  )
};


export const Dot = (props) => {

  let { color, size, className, colorClassName } = props;
  colorClassName = colorClassName || getThemeColor(color, "bg");

  return (
    <div className={`c-dot ${colorClassName} ${className}`} style={{ width: size, height: size }}></div>
  )
};

Dot.defaultProps = {
  color: "primary",
  size: 20,
  className: ''
}


export const DotRow = ({ color, size, title, description, className, titleClassName, go, format, line }) => {

  const renderDescription = (description) => {
    if (!description) return;
    if (Util.type(description) === "string") {
      let p = {};
      p[format] = description;
      return <Html className="c-text-s2 m-text-dark75" textClassName="mb-1" {...p} />;
    }
    return description;
  }

  return (
    <div className={`d-flex flex-column ${className} ${go ? 'c-pointer' : ''}`} onClick={go ? go : null}>
      <div className="d-flex flex-row justify-content-between align-items-center">
        <div className="d-flex flex-row justify-content-start align-items-center">
          <Dot color={color} size={size} className="mr-2" />
          <p className={`mb-0 c-ellipsis-1 ${titleClassName}`}>{title}</p>
        </div>
        {go ? <div><GoLink /></div> : null}
      </div>
      {line ? <Divider className="w-100 my-2" /> : null}
      {
        description ? (
          <div className="d-flex mt-2">
            <div className="c-d-hidden mr-2" style={{ width: size }}></div>
            {renderDescription(description)}
          </div>
        ) : null
      }
    </div>
  )
};

DotRow.defaultProps = {
  className: '',
  color: "primary",
  size: 12,
  title: '',
  titleClassName: 'c-text-s3',
  description: '',
  format: "code"
}


export const DotPanel = ({ color, size, children, className, format, dot, single, textClassName }) => {

  const renderContent = (children) => {
    if (!children) return;
    if (Util.type(children) === "string") {
      if (single) return <p className={`mb-0 ${textClassName}`}>{children}</p>
      let p = {};
      p[format] = children;
      return <Html className={`${textClassName}`} textClassName="mb-1" {...p} />;
    }
    return children;
  }

  return (
    <div className={`d-flex flex-row justify-content-start align-items-start ${className}`}>
      <div className="d-flex flex-column justify-content-center align-items-center px-2 c-mh2">
        {dot ? dot : <Dot color={color} size={size} className="m-0" />}
      </div>
      <div className="d-flex flex-column justify-content-center align-items-start c-mh2 c-flex-1">
        {renderContent(children)}
      </div>
    </div>
  )
};

DotPanel.defaultProps = {
  className: '',
  color: "primary",
  size: 12,
  format: 'code',
  single: false,
  textClassName: 'c-text-s2 m-text-dark75'
}


export const DotPanels = (props) => {
  let { className, data, empty, size, single, textClassName } = props;
  data = data || [];
  return (
    <div className={`d-flex flex-column ${className}`}>
      {data.length === 0 && empty ? <EmptySlim gap={2} className="empty c-text-s2" label={empty} /> : null}
      {data.map((item, i) => {
        return (
          <DotPanel key={i} className="mt-2" single={single} size={size} textClassName={textClassName} color={"success"}>
            {item}
          </DotPanel>
        );
      })}
    </div>
  )
}

DotPanels.defaultProps = {
  className: '',
  single: false,
  textClassName: 'c-text-s2 m-text-dark75'
}


export const getStickyNoteColor = (color) => {
  switch (color) {
    case "yellow": return "#ffe9a3";
    case "red": return "#fad8c7";
    case "green": return "#bfe5bf";
    case "deep": return "#ffb822";
  }
  return getThemeColor(color, "value");
}


const stickyNoteStyles = makeStyles({
  root: props => ({
    background: getStickyNoteColor(props.color),
    padding: props.gap || props.innerGap,
    margin: props.gap || props.outerGap,
    display: "inline-block"
  }),
  container: props => ({
    marginLeft: `-${props.gap}`,
    marginRight: `-${props.gap}`,
    "& p.empty": {
      marginLeft: props.gap,
      marginRight: props.gap,
    },
    "& p.stickyNote": {
      color: "#333"
    }
  })
});


export const StickyNotes = (props) => {
  let classes = stickyNoteStyles(props);
  let { className, data, empty, onItemClick, color, nodeClassName, nodeTextClassName, gap } = props;
  data = data || [];
  return (
    <div className={`d-flex flex-row flex-wrap ${classes.container} ${className}`}>
      {data.length === 0 && empty ? <EmptySlim gap={2} className="empty c-text-s1 m-text-muted" label={empty} /> : null}
      {
        data.map((item, i) => {
          return <StickyNote gap={gap} className={nodeClassName} textClassName={nodeTextClassName} data={item} icon={item.icon} color={item.color || item.Color || color || "yellow"} key={i} onClick={onItemClick} />
        })
      }
    </div>
  )
}

StickyNotes.defaultProps = {
  className: '',
  nodeClassName: '',
  nodeTextClassName: 'c-text-s1',
  gap: "0.5rem"
}


export const StickyNote = (props) => {
  let classes = stickyNoteStyles(props);
  let { className, data, onClick, icon, textClassName, children } = props;
  let ps = {};
  if (onClick) ps.onClick = () => { onClick(data); };
  icon = icon ? createIcon(icon, "c-icon-s2 mr-1") : null;
  return (
    <div className={`d-flex flex-column c-radius stickyNote ${onClick ? 'c-pointer' : ''} ${classes.root} ${className}`} {...ps}>
      {children ? children : <p className={`mb-0 c-wrap ${textClassName}`}>{icon}{data.label || data}</p>}
    </div>
  )
}

StickyNote.defaultProps = {
  className: '',
  color: 'yellow',
  textClassName: 'c-text-s1',
  gap: "0.5rem",
  outerGap: "0.5rem",
  innerGap: "0.5rem"
}



export class Dropdown extends React.Component {

  state = {
    anchorEl: null,
    open: false,
  };

  open = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  render() {
    let { items, className } = this.props;
    return (
      <Menu className={className}
        anchorEl={this.state.anchorEl}
        open={this.state.open}
        onClose={this.handleRequestClose}
        PaperProps={{
          style: {
            minWidth: 120,
            paddingTop: 0,
            paddingBottom: 0
          }
        }}
      >
        {
          items.map(({ label, icon, click }, i) => {
            icon = createIcon(icon, "zmdi-hc-fw mr-2");
            return <MenuItem key={i} onClick={() => {
              this.handleRequestClose();
              click()
            }}>
              {icon}
              {label}
            </MenuItem>
          })
        }
      </Menu>
    );
  }
}

Dropdown.defaultProps = {
  className: '',
  items: []
}


export class DashedPanel extends React.Component {

  constructor(props) {
    super(props);
  }


  render() {
    let { title, children, className, titleClassName, bodyClassName,empty,emptyClassName, line,bodyStyle } = this.props;
    return (
      <div className={`d-flex flex-column ${line ? "c-ld" : ""} w-100 ${className}`}>
        {title?
        <div className={`d-flex c-text-s2 m-text-dark75 justify-content-center align-item-center mt-2 ${titleClassName}`}>{title}</div>
        :null}
        <div className={`d-flex c-flex-1 justify-content-center align-items-center ${bodyClassName}`} style={bodyStyle}>
          {children ? children : <div className={`c-text-s2 text-dark ${emptyClassName}`}>{empty}</div>}
        </div>
      </div>
    )
  }
}

DashedPanel.defaultProps = {
  className: '',
  titleClassName: "",
  bodyClassName:"",
  emptyClassName:'',
  bodyStyle:{},
  empty: "暂无数据"
}
